import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {AppConfig} from '../../app.config';

@Injectable()
export class SpaceService {
  constructor (private http: HttpClient , private api: AppConfig) {
  }

  addSpace (data) {
    return this.http.post(this.api.baseUrl + '/space/addSpace' , data , this.api.jsonTokenHeaders);
  }

  getSpaceBoards (page = 1, perPage = 1000, search = '') {
    return this.http.get(this.api.baseUrl + '/space/spaceBoards?page=' + page + '&perPage=' +
      perPage + '&search=' + search, this.api.jsonTokenHeaders);
  }

  getSpaces (platformId) {
    return this.http.get(this.api.baseUrl + '/space/spacesBack?platformId=' + platformId, this.api.jsonTokenHeaders);
  }

  deleteSpace (id) {
    return this.http.delete(this.api.baseUrl + '/space/deleteSpace?id=' + id , this.api.jsonTokenHeaders);
  }

  addSpaceBoard (data) {
    return this.http.post(this.api.baseUrl + '/spaceBoard/addSpaceBoard' , data , this.api.jsonTokenHeaders);
  }

  deleteSpaceBoard (id) {
    return this.http.delete(this.api.baseUrl + '/spaceBoard/deleteSpaceBoard?id=' + id , this.api.jsonTokenHeaders);
  }
}
